import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import {
  adaptInstructorsToStore
} from './adapters/instructorAdapter'
import { CONTENT } from '@/services/axios.config'

const services = [
  {
    name: 'listInstructors',
    method: 'get',
    url: (params) => `/instructors${buildParamList(params)}`,
    resolver: adaptInstructorsToStore
  },
  {
    name: 'getInstructor',
    method: 'get',
    url: (params) => `/instructors/${params.instructorId}`
  }
]

export const {
  listInstructors,
  getInstructor
} = buildServices(CONTENT, services)